/* eslint-disable no-mixed-operators */
/* eslint-disable security/detect-object-injection */
import { checkIfImageIntersectsPhotozoneEdge } from './check-if-image-intersects-edge';

export const checkIfImageIsOverlapping = ({
  imageCoords,
  photoZoneMarginCoords,
}: {
  imageCoords: [fabric.Point, fabric.Point, fabric.Point, fabric.Point];
  photoZoneMarginCoords: [fabric.Point, fabric.Point, fabric.Point, fabric.Point];
}): boolean => {
  /**
   * Helper: Checks if a point is inside a convex polygon (used for rotated rectangles/quadrilaterals).
   * @param point - The point to check.
   * @param polygon - Array of polygon corner points.
   * @returns true if point is inside polygon, false otherwise.
   */
  const isPointInPolygon = (point: { x: number; y: number }, polygon: Array<{ x: number; y: number }>) => {
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i].x,
        yi = polygon[i].y;
      const xj = polygon[j].x,
        yj = polygon[j].y;
      const intersect =
        yi > point.y !== yj > point.y && point.x < ((xj - xi) * (point.y - yi)) / (yj - yi || 1e-7) + xi;
      if (intersect) inside = !inside;
    }
    return inside;
  };

  // Overlap logic:
  // - If any edge of the image intersects the photozone, or
  // - If any photozone corner is inside the image, or
  // - If any image corner is inside the photozone,
  // then the image is considered overlapping the photozone.
  // Only if there is NO overlap at all, the image is reverted to the last valid position.
  const anyPhotozoneCornerInImage = photoZoneMarginCoords.some((corner) =>
    isPointInPolygon(corner, imageCoords as Array<{ x: number; y: number }>),
  );
  const anyImageCornerInPhotozone = imageCoords.some((corner) =>
    isPointInPolygon(corner, photoZoneMarginCoords as Array<{ x: number; y: number }>),
  );

  // Check if any edge of the image intersects any edge of the photozone (with margin)
  const anyEdgeIntersect = checkIfImageIntersectsPhotozoneEdge({
    imageCoords,
    photoZoneMarginCoords: photoZoneMarginCoords as [fabric.Point, fabric.Point, fabric.Point, fabric.Point],
  });

  return anyEdgeIntersect || anyPhotozoneCornerInImage || anyImageCornerInPhotozone;
};
